export class SkuPriceRequest {
    public skuIds: string;
    public startDate?: string;
    public endDate?: string;
    public periodType: string;
    public includeRegularPrices: boolean;
    public pricePer: string;
    public currency: string;
    public viewBy: string;
}
